import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface Tier {
  name: string;
  setup: string;
  monthly: string;
  note?: string;
  badge?: string;
  feature?: string;
}
interface Group {
  title: string;
  tiers: Tier[];
}
const groups: Group[] = [{
  title: 'SISTEMA COMPLETO',
  tiers: [{
    name: 'START',
    setup: '$4.500.000',
    monthly: '$500.000/mes',
    feature: 'Presencia digital + automatización base'
  }, {
    name: 'GROWTH',
    setup: '$6.000.000',
    monthly: '$900.000/mes',
    feature: 'Presencia digital + automatización completa'
  }, {
    name: 'PRO',
    setup: '$8.000.000',
    monthly: '$1.450.000/mes',
    feature: 'Sistema completo + integraciones avanzadas'
  }]
}];
interface PricingDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PricingDetailModal({
  isOpen,
  onClose
}: PricingDetailModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-203" data-mp="2jwp1quapojwe">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[200] bg-carbon/60 backdrop-blur-sm flex items-center justify-center p-4 md:p-8" role="presentation" onClick={onClose} data-id="element-204" data-mp="2jvnii2jjkr3l">
          <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} role="dialog" aria-modal="true" aria-labelledby="pricing-detail-title" className="relative bg-arena rounded-[12px] max-w-[760px] w-full max-h-[85vh] overflow-y-auto p-8 md:p-10" onClick={e => e.stopPropagation()} data-id="element-205" data-mp="20zxbg0wr54iu">
            <button onClick={onClose} aria-label="Cerrar" className="absolute top-6 right-6 text-carbon/50 hover:text-carbon transition-colors duration-150" data-id="element-206" data-mp="182d1jl2578jw">
              <X size={20} data-id="element-207" data-mp="20raer9rhyf5s" />
            </button>

            <h3 id="pricing-detail-title" className="font-display text-[24px] md:text-[28px] font-bold text-carbon mb-1.5" data-id="element-208" data-mp="1vsqurewgrdg2">
              Configuraciones detalladas
            </h3>
            <p className="font-body text-[14px] text-carbon/55 mb-8" data-id="element-209" data-mp="kg6kyaenkki2">
              Niveles de implementación de Sistema Completo. Los niveles de
              Automatización (START / GROWTH / PRO) y VOICE (CORE / GROWTH /
              SCALE) ya están visibles directamente en la página.
            </p>

            <div className="space-y-8" data-id="element-210" data-mp="2w05pnx3ul560">
              {groups.map(group => <div key={group.title} data-id="element-211" data-mp="30zqqye6hpplw">
                  <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-3" data-id="element-212" data-mp="35s1ppdphv5cv">
                    {group.title}
                  </span>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3" data-id="element-213" data-mp="3aqv6bf02vch9">
                    {group.tiers.map(tier => <div key={tier.name} className="relative bg-arena-dark border border-carbon/10 rounded-[12px] p-4" data-id="element-214" data-mp="3js2siypbkmuz">
                        {tier.badge && <span className="absolute -top-2.5 left-3 bg-azul text-arena font-body text-[9px] font-semibold uppercase tracking-[0.08em] px-2 py-0.5 rounded-full" data-id="element-215" data-mp="1pf3dp7srjwor">
                            {tier.badge}
                          </span>}
                        <span className="block font-display text-[13px] font-bold text-carbon mb-2" data-id="element-216" data-mp="3fvow5qfx22oi">
                          {tier.name}
                        </span>
                        <span className="block font-body text-[13px] text-carbon/70" data-id="element-217" data-mp="3pt3ankia4he6">
                          {tier.setup}
                          {tier.monthly && ' implementación'}
                        </span>
                        {tier.monthly && <span className="block font-body text-[13px] font-medium text-carbon mt-0.5" data-id="element-218" data-mp="2x5yzexslf6ty">
                            {tier.monthly}
                          </span>}
                        {tier.note && <span className="block font-body text-[11px] text-carbon/45 mt-1.5" data-id="element-219" data-mp="2if9pdyqvbxro">
                            {tier.note}
                          </span>}
                        {tier.feature && <span className="block font-body text-[11px] text-carbon/45 mt-1.5 leading-[1.4]" data-id="element-220" data-mp="2497qf2a9h658">
                            {tier.feature}
                          </span>}
                      </div>)}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}